export var getToggledIsActiveState = function getToggledIsActiveState(_ref) {
  var isActive = _ref.isActive;
  return {
    isActive: !isActive
  };
};